export default __webpack_public_path__ + "static/media/rhythm.2ad1a6c4.png";